import { Burst, Cup, TownHall } from "@/components/home/Doodles";
import { PHOTOS, Photo } from "@/components/home/photos";
import { CtaButton } from "@/components/home/HeroSection";

export function MunicipalityCard() {
  return (
    <article className="relative lg:col-span-7 rounded-[28px] bg-ll-forest text-white overflow-hidden lift grid grid-cols-1 sm:grid-cols-5" data-testid="home-card-gemeenten">
      <div className="relative z-10 sm:col-span-3 p-7 sm:p-10">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-white/80">Voor gemeenten <Burst className="w-6 h-6 text-ll-orange" /></p>
        <h2 className="mt-4 font-heading font-semibold text-3xl sm:text-4xl leading-[1.05]">Duurzame participatie begint bij de mens.</h2>
        <p className="mt-5 text-white/85 leading-relaxed text-[15px]">
          LevelLeven ondersteunt gemeenten met een intensieve, mensgerichte aanpak voor inwoners die ondanks bestaande ondersteuning onvoldoende in beweging komen.
        </p>
        <p className="mt-3 text-white/85 leading-relaxed text-[15px]">
          We denken mee over een passende pilot, meetbare ontwikkeling en aansluiting op bestaande voorzieningen.
        </p>
        <div className="mt-7"><CtaButton to="/pilot" variant="light" testid="home-card-gemeenten-cta">Meer over de gemeentelijke pilot</CtaButton></div>
        <TownHall className="absolute bottom-5 right-4 w-20 text-white/40 hidden sm:block" />
      </div>
      <div className="relative sm:col-span-2 min-h-[220px]">
        <Photo photo={PHOTOS.gesprek} sizes="(min-width:1024px) 25vw, 100vw" className="absolute inset-0 w-full h-full" />
        <div className="hidden sm:block absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-ll-forest to-transparent" />
      </div>
    </article>
  );
}

export function ParticipantCard() {
  return (
    <article className="relative lg:col-span-5 rounded-[28px] bg-ll-peach overflow-hidden lift p-7 sm:p-10" data-testid="home-card-deelnemers">
      <span className="absolute -bottom-10 -right-10 w-40 h-40 rounded-full bg-ll-orange/15" aria-hidden="true" />
      <span className="absolute -bottom-6 left-1/3 w-24 h-24 rounded-full bg-ll-sage/25" aria-hidden="true" />
      <Cup className="absolute top-6 right-6 w-14 h-14 text-ll-forest" />
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-ll-ink/70">Voor deelnemers <Burst className="w-6 h-6 text-ll-orange" /></p>
      <h2 className="mt-4 font-heading font-semibold text-3xl sm:text-4xl leading-[1.05] text-ll-forest pr-16">Het leven mag ondertussen ook gewoon weer leuk worden.</h2>
      <p className="relative mt-5 text-ll-ink/85 leading-relaxed text-[15px]">
        In een groep met mensen die ook een nieuwe start willen maken, krijg je ruimte om te ontdekken, te leren en te groeien.
      </p>
      <div className="relative mt-7"><CtaButton to="/voor-jou" variant="outline" testid="home-card-deelnemers-cta">Ik ben deelnemer</CtaButton></div>
    </article>
  );
}

export default function AudienceCards() {
  return (
    <section className="bg-ll-cream py-6 sm:py-10" data-testid="home-doelgroepen">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-6">
        <MunicipalityCard />
        <ParticipantCard />
      </div>
    </section>
  );
}
